import { XMarkIcon } from '@heroicons/react/24/outline';
import UpgradePrompt from './UpgradePrompt';
import { BooleanCapabilityKey } from '../plans/types';

interface PlanUpgradeModalProps {
  capability: BooleanCapabilityKey | null;
  onClose: () => void;
}

export default function PlanUpgradeModal({
  capability,
  onClose,
}: PlanUpgradeModalProps) {
  if (!capability) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div
        className="fixed inset-0 bg-gray-500/75 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-lg rounded-lg bg-white dark:bg-gray-800 p-6 shadow-xl">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 top-4 rounded-md text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
            aria-label="Close"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
          <UpgradePrompt capability={capability} className="border-0 bg-transparent p-0" />
        </div>
      </div>
    </div>
  );
}
